import { ButtonHeading, CommonModal } from "components";
import BootstrapTable from "components/BootstrapTable";
import MastersFilterModal from "modals/MastersFilterModal";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit } from "react-icons/fi";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdCancel } from "react-icons/md";

import {
  changeUserStatusData,
  deleteUserData,
  getUserList,
} from "_services/userService";
import useDocumentTitle from "hooks/useDocumentTitle";
import { FaCheckCircle } from "react-icons/fa";
import { EditUserProfile } from "modals";
import {
  getActiveSessions,
  getMasterData,
  removeLoginSession,
} from "_services";
import { StorageServices } from "utils";

const Session = () => {
  useDocumentTitle("User | MySifarish");
  const getUserData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [userListData, setUserListData] = useState([]);
  const [userDataList, setUserDataList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 20;
  const [isOpen, setIsOpen] = useState(false);
  const [isSuccessMsg, setIsSuccessMsg] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [persistedState, setPersistedState] = useState(location);

  // const [selectedRange, setSelectedRange] = useState({
  //   // startDate: moment().startOf("month"),
  //   // endDate: moment().endOf("month"),
  //   startDate: "",
  //   endDate: "",
  // });

  // const [filter, setFilter] = useState({
  //   userId: "",
  //   page: 1,
  //   limit: 20,
  //   startDate: null,
  //   endDate: null,
  //   isActive: "",
  // });

  const initialFilter = {
    userId: "",
    page: 1,
    limit: 20,
    startDate: "",
    endDate: "",
    keyword: "",
    isActive: "",
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const [filter, setFilter] = useState({
    ...initialFilter,
    userId: searchParams.get("userId") || "",
    page: Number(searchParams.get("page")) || 1,
    limit: Number(searchParams.get("limit")) || 20,
    isActive: searchParams.get("isActive") || "",
    startDate: searchParams.get("startDate")
      ? moment(searchParams.get("startDate"))
      : "",
    endDate: searchParams.get("endDate")
      ? moment(searchParams.get("endDate"))
      : "",
    keyword: searchParams.get("keyword") || "",
  });

  const [selectedRange, setSelectedRange] = useState({
    startDate: filter.startDate,
    endDate: filter.endDate,
  });

  useEffect(() => {
    const params = {};

    Object.entries(filter).forEach(([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        !(moment.isMoment(value) && !value.isValid())
      ) {
        params[key] = moment.isMoment(value)
          ? value.format("YYYY-MM-DD")
          : value;
      }
    });

    setSearchParams(params);
  }, [filter, setSearchParams]);

  const handleReset = () => {
    setFilter(initialFilter);
    setSearchParams({});
    setSelectedRange({ startDate: null, endDate: null });
  };

  const hasActiveFilters = Object.keys(initialFilter).some((key) => {
    if (key === "page" || key === "limit") return false;

    const currentValue = filter[key];
    const initialValue = initialFilter[key];

    const normalize = (val) =>
      val === "" || val === null || val === undefined ? null : val;

    const curr = normalize(currentValue);
    const init = normalize(initialValue);

    if (moment.isMoment(curr)) {
      return (
        curr.isValid() && (!moment.isMoment(init) || !curr.isSame(init, "day"))
      );
    }

    return curr !== init;
  });

  useEffect(() => {
    if (getUserData?._id) {
      // fetchActiveSession();
      fetchlistUserData(getUserData._id);
    }
  }, [getUserData?._id]);

  useEffect(() => {
    if (location?.state && !persistedState) {
      setPersistedState(location);
    }
  }, [location.state]);

  useEffect(() => {
    const id = persistedState?.state?._id;

    if (id) {
      fetchActiveSession(id);
    } else {
      fetchActiveSession();
    }
  }, [filter, selectedRange]);

  const fetchlistUserData = async (data) => {
    try {
      const payload = {
        userId: data,
        limit: -1,
      };
      const res = await getUserList(payload);
      if (res) {
        setUserDataList(res?.data?.users);
      } else {
        toast.error(res?.responseMessage);
        setUserDataList([]);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setUserDataList([]);
    }
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, page }));
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalCount / itemsPerPage);
    const currentPage = filter.page;
    let pages = [];

    const createPageItem = (i) => (
      <li key={i} className={`page-item ${i === currentPage ? "active" : ""}`}>
        <a className="page-link _avPointer" onClick={() => handlePageChange(i)}>
          {i}
        </a>
      </li>
    );

    const rangeStart = Math.max(2, currentPage - 2);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    pages.push(createPageItem(1));

    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }

    return (
      <ul className="pagination">
        <li className={`page-item ${filter.page === 1 ? "disabled" : ""}`}>
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page - 1)}
          >
            <IoChevronBack />
          </a>
        </li>
        {pages}
        <li
          className={`page-item ${
            filter.page === totalPages ? "disabled" : ""
          }`}
        >
          <a
            className="page-link _avPointer"
            onClick={() => handlePageChange(filter.page + 1)}
          >
            <IoChevronForward />
          </a>
        </li>
      </ul>
    );
  };

  const fetchActiveSession = async (data) => {
    setLoading(true);
    try {
      const payload = {
        ...filter,
        startDate: selectedRange.startDate
          ? moment(selectedRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: selectedRange.endDate
          ? moment(selectedRange.endDate).format("YYYY-MM-DD")
          : "",
        userId: data ? data : filter?.userId ? filter?.userId : "",
        isActive: filter?.isActive,
      };
      const res = await getActiveSessions(payload);
      if (res) {
        setUserListData(res?.data?.sessions);
        setTotalCount(res?.data?.totalRecords);
        setLoading(false);
      } else {
        toast.error(res?.responseMessage);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const handleDelete = (item) => {
    setIsDelete(item);
  };

  const submitDeleteUser = async () => {
    const payload = {
      userId: getUserData?._id,
      tokenToRemove: isDelete?.token,
    };
    try {
      const res = await removeLoginSession(payload);
      if (res) {
        fetchActiveSession();
        setIsDelete(false);
        setIsSuccessMsg(res?.message);
        toast.success(res?.message);
      } else {
        toast.error("Error !! ");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setIsDelete(false);
    }
  };

  const propsDelete = {
    isOpen: isDelete,
    closeModal: () => setIsDelete(false),
    modalMainClass: "confirmModal_new",
    footerPart: true,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancelButtonTitle: "Close",
    onSubmit: submitDeleteUser,
  };

  const getUserRoleLabel = (role) => {
    switch (role) {
      case 1:
        return "User";
      case 2:
        return "Admin";
      case 3:
        return "Moderator";
      case 4:
        return "Business";
      default:
        return "-";
    }
  };

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const columns = [
    { header: "", accessor: "serial" },
    { header: "User Name", accessor: "userName" },
    { header: "User Agent", accessor: "userAgent" },
    { header: "IP Address", accessor: "ipAddress" },
    { header: "Active User", accessor: "isActive" },
    { header: "OS", accessor: "os" },
    { header: "OS Version", accessor: "osVersion" },
    { header: "App Version", accessor: "appVersion" },
    { header: "Created Date", accessor: "created_date" },
    // { header: "Role", accessor: "userRole" },
  ];

  const rowListData = (data) =>
    data?.map((item, i) => ({
      ...item,
      serial: (
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            {/* <div className="_avPointer" style={{ textDecoration: "none" }}
              onClick={() => {
                // setUserToEdit(item);
                // setIsOpen(true);
              }}
            >
              <span className="_samAnchor">
                <span className="viewIcon_avt"><FiEdit /></span> Edit
              </span>
            </div> */}
            <div className="_avPointer" onClick={() => handleDelete(item)}>
              <span className="_samAnchor">
                <span className="deleteIcon_avt">
                  <FaRegTrashCan color="red" />
                </span>{" "}
                Remove
              </span>
            </div>
          </div>
        </div>
      ),
      userAgent: item?.userAgent || "-",
      ipAddress: item?.ipAddress || "-",
      os: item?.os || "-",
      osVersion: item?.osVersion || "-",
      appVersion: item?.appVersion || "-",
      created_date: formatDateToDDMMYYYY(item?.createdAt) || "-",
      isActive: <>{item?.isActive && item?.isActive === true ? "Yes" : "No"}</>,
      userName: (
        <Link
          to={`/user/details/${item?.userId?._id}`}
          className="_avPointer"
          style={{ textDecoration: "none", color: "#333333" }}
        >
          <span>
            {item?.userId &&
              `${item?.userId?.firstName} ${item?.userId?.lastName}`}
          </span>
        </Link>
      ),
    }));

  const handleApply = (newRange) => {
    setSelectedRange(newRange);
    setFilter((s) => ({
      ...s,
      page: 1,
      startDate: newRange.startDate,
      endDate: newRange.endDate,
    }));
  };

  const EditUserModal = {
    isOpen,
    closeModal: () => setIsOpen(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Edit User",
    footerPart: true,
    submitTitle: "Edit User",
    onSuccess: () => fetchActiveSession(getUserData._id),
  };

  const handleRemoveTitle = () => {
    navigate(persistedState.pathname, { replace: true });
    fetchActiveSession();
    setPersistedState(null);
  };

  return (
    <>
      {/* {userDataList?.length > 0 && (
        )} */}
        <ButtonHeading
          title={`Sessions `}
          titleName={`${
            persistedState?.state?._id ? persistedState?.state?.firstName : ""
          } ${persistedState?.state?._id ? persistedState?.state?.lastName : ""}`}
          handleRemoveTitle={() => handleRemoveTitle()}
          showCross={persistedState?.state?._id ? true : false}
          showDateRange={true}
          // Export={true}
          // ExportSubmit={exportToCSV}
          selectedRange={selectedRange}
          filter={filter}
          setFilter={setFilter}
          handleApply={handleApply}
          userDataList={userDataList}
          isShow={{
            isActive: true,
            selectedUser: true,
          }}
          handleReset={() => handleReset()}
          showResetFilter={hasActiveFilters}
        />

      <div className="_tabWith_outTab">
        <BootstrapTable
          columns={columns}
          data={rowListData(userListData?.length > 0 ? userListData : [])}
          isLoading={loading}
          colSpan={8}
        />
        <div className="paginationFt_avt">{renderPagination()}</div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${
          showFilterModal ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {isOpen && userToEdit && (
        <EditUserProfile
          userId={getUserData?._id}
          userIdToUpdate={userToEdit._id}
          userData={userToEdit}
          props={EditUserModal}
        />
      )}

      {isDelete?._id && (
        <CommonModal {...propsDelete}>
          <p className="p-3"> Are you sure to remove this session?</p>
        </CommonModal>
      )}
    </>
  );
};

export default Session;
